import styled from 'styled-components';
import { Box } from '../CommonComponents/OPL/Box/Box';

export const Content = styled(Box)({
  minHeight: 'calc(100vh - 380px)',
});
